export const types = {
  EPG_DATA_FETCH: 'EPGGrid/EPG_DATA_FETCH',
  EPG_DATA_FETCH_FAILURE: 'EPGGrid/EPG_DATA_FETCH_FAILURE',
  EPG_DATA_FETCH_SUCCESS: 'EPGGrid/EPG_DATA_FETCH_SUCCESS',
  EPG_DATA_ID: 'EPGGrid/EPG_DATA_ID',
  EPG_INPUT_SEARCH: 'EPGGrid/EPG_INPUT_SEARCH',
  EPG_SWIPER_VIRTUAL_SIZE_PX_WIDTH: 'EPGGrid/EPG_SWIPER_VIRTUAL_SIZE_PX_WIDTH',
  EPG_SWIPER_SLIDE_LENGTH: 'EPGGrid/EPG_SWIPER_SLIDE_LENGTH',
  EPG_SWIPER_SLIDE_PER_VIEW: 'EPGGrid/EPG_SWIPER_SLIDE_PER_VIEW',
  EPG_TIME_LIST_IN_DAY: 'EPGGrid/EPG_TIME_LIST_IN_DAY',
  EPG_CURRENT_TIME: 'EPGGrid/EPG_CURRENT_TIME',
  EPG_BRODCAST_LIVE: 'EPGGrid/EPG_BRODCAST_LIVE',
  SELECTED_DAY_CHANGED: 'EPGGrid/SELECTED_DAY_CHANGED',
  SELECTED_PROGRAM_ITEM: 'EPGGrid/SELECTED_PROGRAM_ITEM',
  DESELECTED_PROGRAM_ITEM: 'EPGGrid/DESELECTED_PROGRAM_ITEM',
  SELECTED_CATEGORY_CHANGED: 'EPGGrid/SELECTED_CATEGORY_CHANGED',
};
